import { render, staticRenderFns } from "./PricesTable.vue?vue&type=template&id=4f18c932&scoped=true&"
import script from "./PricesTable.vue?vue&type=script&lang=js&"
export * from "./PricesTable.vue?vue&type=script&lang=js&"
import style0 from "./PricesTable.vue?vue&type=style&index=0&id=4f18c932&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f18c932",
  null
  
)

/* custom blocks */
import block0 from "./PricesTable.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./PricesTable.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VRow})
